import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Megane from "./pages/Megane";
import PhotoFrame from "./pages/PhotoFrame";
import Home from "./pages/Home";
import DesktopWarning from "./components/DesktopWarning";
import "./App.css";

function App() {
  return (
    <Router>
      {/* デスクトップ警告表示 */}
      <DesktopWarning />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/megane" element={<Megane />} />
        <Route path="/photoframe" element={<PhotoFrame />} />
      </Routes>
    </Router>
  );
}

export default App;
